import axios from '../http-common';

const createAxiosRequest = (token) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};

	return {
		get: (url, params = {}) => axios.get(url, { ...config, ...params }),
		post: (url, data) => axios.post(url, data, config),
		put: (url, data) => axios.put(url, data, config),
		delete: (url) => axios.delete(url, config),
	};
};

const axiosWithToken = createAxiosRequest;

export const AdminServices = {
	getListForAdmin: (token, name, categories, regulation, page) =>
		axiosWithToken(token).get(`/admin/list-users/`, {
			params: { search: name, categories, regulation, page },
		}),
	getUserDetails: (token, id) => axiosWithToken(token).get(`/admin/list-users/${id}`),
	create_user_admin: (token, data) => axiosWithToken(token).post('/admin/list-users/add', data),
	updateUserByAdmin: (token, id, data) =>
		axiosWithToken(token).put(`/admin/list-users/${id}`, data),
	updateProfile: (token, data) => axiosWithToken(token).put(`/admin/profile/`, data),
	getCategoriesForAdmin: (token, name, page) =>
		axiosWithToken(token).get(`/admin/categories/`, {
			params: { search: name, page },
		}),
	getCategoriesForAdminProducts: (token) => axiosWithToken(token).get(`/admin/categories/products`),
	deleteCategoriesForAdmin: (token, id) => axiosWithToken(token).delete(`/admin/categories/${id}`),
	addCategoryForAdmin: (token, data) => axiosWithToken(token).post(`/admin/categories`, data),
	updateCategoryForAdmin: (token, id, data) =>
		axiosWithToken(token).put(`/admin/categories/${id}`, data),
	blockUserForAdmin: (token, id, data) =>
		axiosWithToken(token).post(`/admin/list-users/block/${id}`, data),
	getListProducts: (token, name, category_name, page) =>
		axiosWithToken(token).get(`/admin/products/`, {
			params: { search: name, categories: category_name, page },
		}),
	updateDeliveryStatus: (token, id, status) =>
		axiosWithToken(token).put(`/admin/delivery/${id}/status`, { status }),
	getProductDetails: (token, id) => axiosWithToken(token).get(`/admin/products/${id}`),
	getOrdersProducts: (token, search, category_name, page) =>
		axiosWithToken(token).get(`/admin/orders/products/`, {
			params: { search, categories: category_name, page },
		}),
	productActivation: (token, id, data) =>
		axiosWithToken(token).put(`/admin/products/block/${id}`, data),
	addProductAdmin: (token, data) => axiosWithToken(token).post(`/admin/products`, data),
	updateProductAdmin: (token, id, data) => axiosWithToken(token).put(`/admin/products/${id}`, data),
	deleteProductAdmin: (token, id) => axiosWithToken(token).delete(`/admin/products/${id}`),
	updateStockAdmin: (token, id, data) =>
		axiosWithToken(token).put(`/admin/products/stock/${id}`, data),
	getListOrdersAdmin: (token, page, search, status) =>
		axiosWithToken(token).get(`/admin/orders/`, {
			params: { page, search, status },
		}),
	deleteOrderAdmin: (token, id) => axiosWithToken(token).delete(`/admin/orders/${id}`),
	getOrderByIdAdmin: (token, id) => axiosWithToken(token).get(`/admin/orders/${id}`),
	updateOrderByIdAdmin: (token, id, data) => axiosWithToken(token).put(`/admin/orders/${id}`, data),
	clientsOrderListAdmin: (token, value) =>
		axiosWithToken(token).get(`/admin/orders/customer/${value}`),
	addOrderAdmin: (token, data) => axiosWithToken(token).post(`/admin/orders`, data),
	getClaims: (token, status, search, page) =>
		axiosWithToken(token).get(`/admin/claim`, {
			params: { search, status, page },
		}),
	getClaimById: (token, id) => axiosWithToken(token).get(`/admin/claim/${id}`),
	updateClaimStatus: (token, id, status) =>
		axiosWithToken(token).put(`/admin/claim/${id}`, { status }),
	getReturns: (token, search, page) =>
		axiosWithToken(token).get(`/admin/return`, {
			params: { search, page },
		}),
	getBills: (token, search, page) =>
		axiosWithToken(token).get(`/admin/bills`, {
			params: { search, page },
		}),
	addDelivery: (token, companyOrderId) =>
		axiosWithToken(token).post(`/admin/delivery/${companyOrderId}`),
	getDelivery: (token, page, search, status, statusCommerial) =>
		axiosWithToken(token).get(
			`/admin/delivery?page=${page}&search=${search}&status=${status}&commercial_status=${statusCommerial}`,
		),
	getDeliveryById: (token, id) => axiosWithToken(token).get(`/admin/delivery/details/${id}`),
	updateDelivery: (token, id, data) =>
		axiosWithToken(token).put(`/admin/delivery/update/${id}`, data),
	checkStock: (token, list) =>
		axiosWithToken(token).post(`/admin/orders/products/stock`, { list: list }),
	getCommercial: (token) => axiosWithToken(token).get(`/admin/delivery/commercial`),
	addVehicle: (token, data) => axiosWithToken(token).post(`/admin/vehicle/`, data),
	deleteVehicle: (token, id) => axiosWithToken(token).delete(`/admin/vehicle/${id}`),
	getPayementDetails: (token, delivery_id) =>
		axiosWithToken(token).get(`/admin/delivery/payement/${delivery_id}`),
	addPayementDelivery: (token, delivery_id, data) =>
		axiosWithToken(token).post(`/admin/delivery/payement/${delivery_id}`, data),
	updatePayementDelivery: (token, payment_id, data) =>
		axiosWithToken(token).put(`/admin/delivery/payement/update/${payment_id}`, data),
	deletePayementDelivery: (token, payment_id) =>
		axiosWithToken(token).delete(`/admin/delivery/payement/delete/${payment_id}`),
	confirmPayement: (token, id, data) =>
		axiosWithToken(token).put(`/admin/delivery/payement/status/${id}`, data),
	refusePayement: (token, id, data) =>
		axiosWithToken(token).put(`/admin/delivery/payement/status/${id}`, data),
	getReturnById: (token, id) => axiosWithToken(token).get(`/admin/return/${id}`),
	getBillById: (token, id) => axiosWithToken(token).get(`/admin/bills/${id}`),
	getAdminDashboard: (token) => axiosWithToken(token).get('/admin/dashboard'),
	getMyCompany: (token) => axiosWithToken(token).get('/admin/company/my-company'),
	updateCompany: (token, data) => axiosWithToken(token).put('/admin/company/updateCompany', data),
	addActuality: (token, data) => axiosWithToken(token).post('/admin/company/actuality', data),
	updateActuality: (token, actualityId, data) =>
		axiosWithToken(token).put(`/admin/company/actuality/${actualityId}`, data),
	deleteActuality: (token, actualityId) =>
		axiosWithToken(token).delete(`/admin/company/actuality/${actualityId}`),
	getActualites: (token) => axiosWithToken(token).get('/admin/company/actualites'),
	getActualityById: (token, actualityId) =>
		axiosWithToken(token).get(`/admin/company/actuality/${actualityId}`),

	addCertificate: (token, data) => axiosWithToken(token).post('/admin/company/certificate', data),
	updateCertificate: (token, certificateId, data) =>
		axiosWithToken(token).put(`/admin/company/certificate/${certificateId}`, data),
	deleteCertificate: (token, certificateId) =>
		axiosWithToken(token).delete(`/admin/company/certificate/${certificateId}`),
	getCertificates: (token) => axiosWithToken(token).get('/admin/company/certificates'),
	getCertificateById: (token, certificateId) =>
		axiosWithToken(token).get(`/admin/company/certificate/${certificateId}`),
	getFinancementList: (token, page, status, search) => {
		let url = `/admin/financement/list?page=${page || 1}&limit=10`;
		if (status) url += `&status=${status}`;
		if (search) url += `&search=${search}`;
		return axiosWithToken(token).get(url);
	},
	addFinancement: (token, data) => axiosWithToken(token).post('/admin/financement/add', data),
	updateFinancement: (token, id, data) =>
		axiosWithToken(token).put(`/admin/financement/update/${id}`, data),
	deleteFinancement: (token, id) => axiosWithToken(token).delete(`/admin/financement/delete/${id}`),
  createFactureFromBill: (token, billId) => axiosWithToken(token).post(`/admin/facture/create/${billId}`),
  getAllFactures: (token, search, page) =>
    axiosWithToken(token).get(`/admin/facture/getAll`, {
        params: { search, page },
    }),
    getFactureById: (token, id) => axiosWithToken(token).get(`/admin/facture/${id}`),
    createFactureProforma: (token, data) => 
    axiosWithToken(token).post(`/admin/facture/creation`, data),
};

export default AdminServices;
